import { Directive } from '@angular/core';

/**
 * One offered answer in a search list. Applied to the button itself so a row keeps its own content
 * and its own selected-state binding, while every list highlights and focuses the same way.
 */
@Directive({
  selector: 'button[guaranteesOption]',
  standalone: true,
  host: {
    class:
      'flex w-full items-center gap-2 px-2 py-1 text-left text-sm transition-colors duration-150 hover:bg-primary-50 focus-visible:bg-primary-50 focus-visible:outline-none motion-reduce:transition-none',
  },
})
export class OptionRowDirective {}
